import { useState } from "react";
import { closeContactForm } from "../../Functions/contactFormFunctions";
import SendEmail from "../../Functions/emailFunctions";
import "./style.scss";

const ContactForm: React.FC = () => {
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phoneNmb, setPhoneNmb] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [errorMsg, setErrorMsg] = useState<string>("");

  function preSendEmail() {
    const result = SendEmail(name, email, phoneNmb, title, message);

    // Handle both string return and Promise return
    if (typeof result === "string") {
      setErrorMsg(result);
    } else if (result && typeof result.then === "function") {
      result.then((res) => {
        if (res) setErrorMsg(res);
      });
    }

    //Resetting the values of the inputs
    setName("");
    setEmail("");
    setPhoneNmb("");
    setTitle("");
    setMessage("");
  }

  return (
    <div id="contactForm" className="contactForm notActive">
      <div className="contactFormHeader">
        <div className="headerText">
          <h1 className="headerTitle">Get in Touch</h1>
          <p className="headerSubtitle">Free, no-obligation quotations</p>
        </div>
        <div className="closeButton">
          <span
            onClick={closeContactForm}
            className="material-symbols-outlined"
          >
            close
          </span>
        </div>
      </div>

      <div className="formContainer">
        <div className="contentWrapper">
          <form action="#">
            <div className="inputGroup">
              <label htmlFor="name">Name</label>
              <input
                id="name"
                type="text"
                placeholder="Your full name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="inputGroup">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                placeholder="email@address.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="inputGroup">
              <label htmlFor="phone">Phone Number</label>
              <input
                id="phone"
                type="text"
                placeholder="e.g. 01234 567890"
                value={phoneNmb}
                onChange={(e) => setPhoneNmb(e.target.value)}
              />
            </div>

            <div className="inputGroup">
              <label htmlFor="title">Subject</label>
              <input
                id="title"
                type="text"
                placeholder="What is this regarding?"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            <div className="inputGroup">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                placeholder="How can we help you?"
                rows={4}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
            </div>

            <button type="button" onClick={() => preSendEmail()}>
              Send Message
            </button>

            {errorMsg ? <p className="errorMsg">{errorMsg}</p> : null}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
